/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable prettier/prettier */
/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/order */
import { FC, useCallback, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { buildValidationSchema } from './schema';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button, Grid, TextField, Typography } from '@mui/material';
import {
  useUpdateSubsidiaryMutation,
} from '@bvi/admin-panel/entities/subsidiary/api-slice';
import {
  useUpdateOrganizationMutation,
} from '@bvi/admin-panel/entities/organization/api-slice';
import { Form } from '@bvi/common-components';
import { LoadingButton } from '@mui/lab';
import { IManageBaseData } from '@bvi/api-interfaces/response/manage-base-data';
import { ManageBaseDataKeys } from '@bvi/api-interfaces/entity/manage-base';
import { useUpdatePerpetratorMutation } from '@bvi/admin-panel/entities/perpetrator/api-slice';
import { useUpdateDefenseMutation } from '@bvi/admin-panel/entities/defense/api-slice';
import { useUpdateExceptionMutation } from '@bvi/admin-panel/entities/exception/api-slice';
import { useUpdateOrganizationTypeMutation } from '@bvi/admin-panel/entities/organization-type/api-slice';
import { useUpdateJobPositionMutation } from '@bvi/admin-panel/entities/job-position/api-slice';
import { useUpdateOrderMutation } from '@bvi/admin-panel/entities/order/api-slice';
import { useUpdateDamageMutation } from '@bvi/admin-panel/entities/damage/api-slice';
import { useUpdateCountryMutation } from '@bvi/admin-panel/entities/country/api-slice';
interface IEditManageFormProps {
  id: number;
  type: string;
  detail: IManageBaseData | null;
  onSuccess?: () => void;
}

interface IEditManageFormValues {
  name: string;
}

export const EditManageForm: FC<IEditManageFormProps> = ({
  id,
  type,
  detail,
  onSuccess,
}) => {
  const { t } = useTranslation();
  const validationSchema = buildValidationSchema(t);

  const methods = useForm<IEditManageFormValues>({
    resolver: zodResolver(validationSchema),
    defaultValues: {
      name: detail?.name || '',
    },
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = methods;

  const [updateSubsidiary, { isLoading: isUpdatingSubsidiary }] = useUpdateSubsidiaryMutation();
  const [updateOrganization, { isLoading: isUpdatingOrganization }] = useUpdateOrganizationMutation();
  const [updatePerpetrator, { isLoading: isUpdatingPerpetrator }] = useUpdatePerpetratorMutation();
  const [updateDefense, { isLoading: isUpdatingDefense }] = useUpdateDefenseMutation();
  const [updateException, { isLoading: isUpdatingException }] = useUpdateExceptionMutation();
  const [updateOrganizationType, { isLoading: isUpdatingOrganizationType }] = useUpdateOrganizationTypeMutation();
  const [updateJobPosition, { isLoading: isUpdatingJobPosition }] = useUpdateJobPositionMutation();
  const [updateOrder, { isLoading: isUpdatingOrder }] = useUpdateOrderMutation();
  const [updateDamage, { isLoading: isUpdatingDamage }] = useUpdateDamageMutation();
  const [updateCountry, { isLoading: isUpdatingCountry }] = useUpdateCountryMutation();

  const handleSetState = useCallback(
    (name: string) => {
      return async () => {
        switch (type) {
          case ManageBaseDataKeys.SUBSIDIARIES: {
            await updateSubsidiary([id, { name }]).unwrap();
            break;
          }
          case ManageBaseDataKeys.ORGANIZATIONS: {
            await updateOrganization([id, { name }]).unwrap();
            break;
          }
          case ManageBaseDataKeys.PERPETRATORS: {
            await updatePerpetrator([id, { name }]).unwrap();
            break;
          }
          case ManageBaseDataKeys.DEFENSES: {
            await updateDefense([id, { name }]).unwrap();
            break;
          }
          case ManageBaseDataKeys.EXCEPTIONS: {
            await updateException([id, { name }]).unwrap();
            break;
          }
          case ManageBaseDataKeys.ORGANIZATION_TYPES: {
            await updateOrganizationType([id, { name }]).unwrap();
            break;
          }
          case ManageBaseDataKeys.JOB_POSITIONS: {
            await updateJobPosition({ id, name }).unwrap();
            break;
          }
          case ManageBaseDataKeys.ORDERS: {
            await updateOrder([id, { name }]).unwrap();
            break;
          }
          case ManageBaseDataKeys.DAMAGES: {
            await updateDamage([id, { name }]).unwrap();
            break;
          }
          case ManageBaseDataKeys.COUNTRIES: {
            await updateCountry({ id, name }).unwrap();
            break;
          }
          default: {
            break;
          }
        }
      };
    },
    [
      id,
      type,
      updateSubsidiary,
      updateOrganization,
      updateOrganizationType,
      updatePerpetrator,
      updateDefense,
      updateException,
      updateJobPosition,
      updateOrder,
      updateDamage,
      updateCountry,
    ],
  );

  const onSubmit = async (data: any) => {
    await handleSetState(data.name)();
    onSuccess?.();
  };

  return (
    <>
      <FormProvider {...methods}>
        <Typography variant="h1" mb={3}>
          {t('manageList.form.editTitle')}
        </Typography>
        <Form
          noValidate
          tabIndex={1}
          onSubmit={handleSubmit(onSubmit)}
          sx={{ width: '400px' }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                {...register('name')}
                variant="outlined"
                defaultValue={detail?.name || ''}
                fullWidth
                label={t('manageList.form.fields.name.label')}
                placeholder={t('manageList.form.fields.name.placeholder')}
                error={Boolean(errors.name)}
                helperText={<>{errors.name?.message}</>}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} marginTop={1}>
            <LoadingButton
              type="submit"
              variant="contained"
              fullWidth
              loading={
                isUpdatingSubsidiary ||
                isUpdatingOrganization ||
                isUpdatingOrganizationType ||
                isUpdatingPerpetrator ||
                isUpdatingDefense ||
                isUpdatingException ||
                isUpdatingJobPosition ||
                isUpdatingOrder ||
                isUpdatingDamage ||
                isUpdatingCountry
              }
              autoFocus
            >
              {t('companies.edit.form.submit')}
            </LoadingButton>
          </Grid>
        </Form>
      </FormProvider>
    </>
  );
};
